import React from 'react'
import { HStack } from '@musinsa/mwms-ds'
import { Typography } from '@musinsa/layer-components-desktop'
import Text from '@/components/content/Text'

interface TitleSectionProps {
  title?: React.ReactNode
  customRight?: React.ReactNode
  /** @deprecated 기존 페이지 하위호환용. 리뉴얼 디자인 이관 완료 후 제거 예정 */
  variant?: 'legacy' | 'renewal'
}

const TitleSection = ({ title, customRight, variant = 'renewal' }: TitleSectionProps) => {
  return (
    <HStack align="center" justify="space-between">
      <HStack align="center">
        {variant === 'legacy' ? (
          <Text kind="Headline_20_bold">{title}</Text>
        ) : (
          <Typography name="base-title-l-semibold" colorToken="fg">
            {title}
          </Typography>
        )}
      </HStack>
      {customRight && (
        <HStack gap={24} align="center">
          {customRight}
        </HStack>
      )}
    </HStack>
  )
}

export default TitleSection
